module.exports = __webpack_public_path__ + "img/slide_001_h1.3217aa7d.jpg";